/* =========================
   WEATHER CHECK (SAFE)
========================= */
/*
$.ajax({
  url: "https://vipankumar.in/open-2.php",
  method: "GET",
  dataType: "json",
  success: function (response) {
    if (response && (response.now === "Rain" || response.future === "Rain")) {
      document.body.classList.add("raining");
      console.log("Rain detected");
    } else {
      document.body.classList.remove("raining");
      console.log("No rain");
    }
  },
  error: function (xhr, status, error) {
    console.error("Weather API error:", status, error);
  }
});
*/


/* =========================
   SLICK SLIDERS (SAFE)
========================= */
if ($.fn.slick) {
  $(".comapny-logo-two .logo-list__content").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    pauseOnHover: false,
    cssEase: "linear",
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 992, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }
    ]
  });

  $(".company-logo .logo-list__content").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    pauseOnHover: false,
    cssEase: "linear",
    arrows: false,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }
    ]
  });
}


/* =========================
   INTERSECTION OBSERVER
========================= */
$(document).ready(function () {
  var $sections = $(".popular-products");
  if (!$sections.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle("in-view", entry.isIntersecting);
    });
  }, { threshold: 0.1 });

  $sections.each(function () {
    observer.observe(this);
  });
});


/* =========================
   UPCART LABEL FIX
========================= */
var intervalId = setInterval(function () {
  var elements = document.querySelectorAll(".upcart-item-property strong");
  if (!elements.length) return;

  elements.forEach(function (el) {
    el.textContent = el.textContent
      .replace("_job_start_time", "Service Date")
      .replace("_address", "Service Location");
  });

  clearInterval(intervalId);
}, 500);


/* =========================
   MAP TOGGLE
========================= */
$(".map-with-tabs span.load_more_btn").on("click", function () {
  var $current = $(this).closest(".content").find(".layer_2");
  $(".map-with-tabs .layer_2").not($current).slideUp();
  $current.stop(true, true).slideToggle();
});


/* =========================
   CONTACT FORM
========================= */
$(".custom_contact_form").hide();

$(".custom_contact_form .close_button, .custom_contact_form .skip_popup_button")
  .on("click", function () {
    $(".custom_contact_form").hide()
      .find("input").val("");
  });


/* =========================
   CONTACT REDIRECT
========================= */
$(document).ready(function () {
  if (window.location.href === "https://clubexecauto.com/?contact_posted=true#ContactForm1") {
    window.location.href = "https://clubexecauto.com/pages/book-an-appointment/";
  }
});


/* =========================
   AUTO PLAY PRODUCT VIDEO
========================= */
$(window).on("load", function () {
  const posterBtn = document.querySelector(".product .deferred-media__poster-button");
  if (posterBtn) posterBtn.click();

  const video = document.querySelector(".deferred-media video");
  if (video) video.play();
});


/* =========================
   TAWK CHAT MOBILE FIX
========================= */
window.onload = function () {
  setTimeout(function () {
    if (window.innerWidth >= 768) return;

    var chatWidget = document.querySelector("iframe[src*='tawk.to']");
    if (!chatWidget) return;

    Object.assign(chatWidget.style, {
      width: "300px",
      height: "400px",
      bottom: "20px",
      right: "20px",
      borderRadius: "10px",
      overflow: "hidden",
      zIndex: "9999"
    });
  }, 3000);
};


/* =========================
   RAIN CANVAS (SAFE)
========================= */
document.addEventListener("DOMContentLoaded", function () {
  const canvas = document.getElementById("rain-canvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  let width = canvas.width = window.innerWidth;
  let height = canvas.height = window.innerHeight;

  const raindrops = Array.from({ length: 300 }, () => ({
    x: Math.random() * width,
    y: Math.random() * height,
    length: Math.random() * 20 + 10,
    speed: Math.random() * 4 + 4
  }));

  function drawRain() {
    ctx.clearRect(0, 0, width, height);
    ctx.strokeStyle = "rgba(173,216,230,0.6)";
    ctx.lineWidth = 1;

    raindrops.forEach(drop => {
      ctx.beginPath();
      ctx.moveTo(drop.x, drop.y);
      ctx.lineTo(drop.x, drop.y + drop.length);
      ctx.stroke();

      drop.y += drop.speed;
      if (drop.y > height) {
        drop.y = -drop.length;
        drop.x = Math.random() * width;
      }
    });

    requestAnimationFrame(drawRain);
  }

  drawRain();

  window.addEventListener("resize", function () {
    width = canvas.width = window.innerWidth;
    height = canvas.height = window.innerHeight;
  });
});


/* =========================
   DISCOUNT AFTER ADD TO CART
========================= */
document.addEventListener("click", function (e) {
  const btn = e.target.closest("button.rain_discountt");
  if (!btn) return;
  if (!document.body.classList.contains("raining")) return;

  setTimeout(function () {
    window.location.href = "/cart?discount=Rain20";
  }, 1200);
});
